import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import { useGetCheckAccessAppealRegistration } from '../../../api-refactored/appeal/useGetCheckAccessAppealRegistration';
import LoadingComponent from '../../../components/LoadingComponent';
import OpsAdminAppealAccessGrantTable from '../../../modules/appeal/components/@opadmin/OpsAdminAppealAccessGrantTable';

const OpsAdminResultAppealAccess = () => {
  const { t } = useTranslation();

  const { isLoading } = useGetCheckAccessAppealRegistration();

  return isLoading ? (
    <LoadingComponent />
  ) : (
    <>
      <TitleHeader title={t('appeal->>ResultAppealAccess.Title')} />

      <OpsAdminAppealAccessGrantTable />
    </>
  );
};
export default OpsAdminResultAppealAccess;
